import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useCanDeleteInstalledPlugins from "shared/Plugins/access/useCanDeleteInstalledPlugins";
import { Plugin } from "types/generated";

import { showDeleteConfirmation } from "../DeleteConfirmatio";
import { showPluginDetailsDrawer } from "../PluginTemplateDetailsDrawer";

const PluginsTableActionsCell = ({ item: plugin, ...cellProps }: TableSimpleCellProps<Plugin>) => {
  const canDeleteInstalledPlugin = useCanDeleteInstalledPlugins()(plugin);

  const handleDelete = () => {
    showDeleteConfirmation({
      id: plugin.id,
      name: plugin.name,
    });
  };

  const handleViewDetails = () => {
    showPluginDetailsDrawer({ plugin });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Plugin actions">
        <DropdownMenuItem onAction={handleViewDetails}>Details</DropdownMenuItem>
        <CopyFieldDropdownMenuItem title="Copy stack label" value={plugin.labelIdentifier} />
        <DropdownMenuItem
          onAction={handleDelete}
          isDisabled={!canDeleteInstalledPlugin.result}
          tooltip={canDeleteInstalledPlugin.message}
          danger
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default PluginsTableActionsCell;
